import React from 'react';
import {
  NavLink,
  Flex,
} from '../../coreui';

const BrowseNav = () => {
  return (
    <Flex
      align="center"
      justify="center"
      pt={40}
      pb={10}
    >
      <Flex
        w={[275, 1]}
        align="center"
        justify="center"
      >
        <NavLink
          to="/investment-opportunities"
          type="L7"
          mr={[2.5, 10]}
          textAlign="center"
          transition="all 0.5s linear"
        >
          OPEN INVESTMENTS
        </NavLink>
        <NavLink
          type="L7"
          to="/past-investments"
          ml={[2.5, 10]}
          textAlign="center"
          transition="all 0.5s linear"
        >
          PAST INVESTMENTS
        </NavLink>
      </Flex>
    </Flex>
  );
};

export default BrowseNav;
